export const JSON_ERROR_ACTIONS = {
    UPDATE_ERROR: 'UPDATE_ERROR'
};